import { render, staticRenderFns } from "./signaturePad.vue?vue&type=template&id=1be5b8d2&scoped=true"
import script from "./signaturePad.vue?vue&type=script&lang=js"
export * from "./signaturePad.vue?vue&type=script&lang=js"
import style0 from "./signaturePad.vue?vue&type=style&index=0&id=1be5b8d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be5b8d2",
  null
  
)

export default component.exports